import React, { useEffect, useState } from "react";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "../lib/siteData";

export default function Testimonials() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % TESTIMONIALS.length), 5000);
    return () => clearInterval(t);
  }, []);

  return (
    <section className="section-pad bg-slate-900 text-white relative overflow-hidden" data-testid="testimonials-section">
      <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "radial-gradient(circle at 20% 20%, #2563eb 0%, transparent 40%), radial-gradient(circle at 80% 80%, #f59e0b 0%, transparent 40%)" }} />
      <div className="container-narrow relative">
        <div className="text-center mb-12">
          <div className="badge-eco bg-blue-600/10 border-blue-600/30 text-blue-300 mb-3">Testimonials</div>
          <h2 className="text-3xl sm:text-4xl font-heading font-semibold">What our customers say</h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative p-8 sm:p-12 rounded-3xl bg-gradient-to-br from-slate-800 to-slate-900 border border-slate-700 shadow-2xl">
            <Quote className="w-10 h-10 text-blue-600/40 absolute top-6 right-6" />
            <div className="flex gap-1 mb-5">
              {Array.from({ length: TESTIMONIALS[idx].rating }).map((_, i) => (
                <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" />
              ))}
            </div>
            <p className="text-lg sm:text-xl text-slate-200 leading-relaxed mb-6 min-h-[120px]">
              "{TESTIMONIALS[idx].text}"
            </p>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-400 to-blue-700 flex items-center justify-center font-heading font-bold">
                {TESTIMONIALS[idx].name.charAt(0)}
              </div>
              <div>
                <div className="font-heading font-semibold">{TESTIMONIALS[idx].name}</div>
                <div className="text-sm text-slate-400">{TESTIMONIALS[idx].role}</div>
              </div>
            </div>
          </div>
          <div className="flex justify-center gap-2 mt-6">
            {TESTIMONIALS.map((_, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                className={`h-2 rounded-full transition-all ${i === idx ? "bg-blue-600 w-8" : "bg-slate-700 w-2"}`}
                aria-label={`Show testimonial ${i + 1}`}
                data-testid={`testimonial-dot-${i}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
